import React from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "./ui/alert-dialog";
import { Compass } from "lucide-react";

const MODE_LABELS = {
  objects: "Per oggetti", area: "Per area", image: "Da immagine", text: "Da testo",
};

export default function GuidePrompt({ open, mode, onYes, onNo }) {
  const label = MODE_LABELS[mode] || "questo preventivo";
  return (
    <AlertDialog open={open} onOpenChange={(o) => { if (!o) onNo(); }}>
      <AlertDialogContent data-testid="guide-prompt">
        <AlertDialogHeader>
          <div className="h-11 w-11 rounded-full bg-[#1a5f5a]/10 flex items-center justify-center mb-1">
            <Compass className="h-5 w-5 text-[#1a5f5a]" />
          </div>
          <AlertDialogTitle>Vuoi una guida passo-passo?</AlertDialogTitle>
          <AlertDialogDescription>
            Ti mostro cosa scrivere e dove cliccare per creare un preventivo in modalità "{label}". Puoi saltarla e riaprirla quando vuoi dal pulsante "Guida".
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onNo} data-testid="guide-prompt-no">No, faccio da solo</AlertDialogCancel>
          <AlertDialogAction onClick={onYes} className="bg-[#1a5f5a] hover:bg-[#134744]" data-testid="guide-prompt-yes">
            Sì, guidami
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
